module.exports = __webpack_public_path__ + "static/media/manguera-verde.0992e607.svg";